import React, { useContext } from "react";
import { getStoreDownloadUrl } from "../../../config/utils";
import { ClavaContext } from "../../../config/contexts";
import { translate } from "../../../config/translator";

import mockup from "../../../assets/images/mockupNew.png";
import appPlayStoresLogos from "../../../assets/images/appPlayStoreLogos.png";

type StoreBannerProps = {
  className?: string;
  message?: string;
  border?: boolean;
};

const StoreBanner: React.FC<StoreBannerProps> = ({ className, message, border = true }) => {
  const { l } = useContext(ClavaContext);
  return (
    <div
      className={`${className ?? ""} bg-white dark:bg-bg-secondary-dark py-5 px-6 xl:py-4 xl:px-8 relative ${border ? "border border-light-gray dark:border-light-gray-dark" : ""} w-full rounded-xl`}>
      <div className="w-full flex flex-col items-center text-center">
        {message ? (
          <div className="w-full mb-3 flex justify-center">
            <h3 className="text-center text-font dark:text-font-dark text-sm font-semibold">
              {message}
            </h3>
          </div>
        ) : null}
        <img
          alt="App"
          title="App"
          src={mockup}
          className="w-full max-w-xs mt-0"
        />
        <div className="w-full mt-2 flex items-center justify-center">
          <img
            src={appPlayStoresLogos}
            alt="App Store and Play Store"
            title="App Store and Play Store"
            className="w-auto max-w-24 xl:max-w-28"
          />
        </div>
        <div className="w-full mt-4 flex justify-center">
          <a
            href={getStoreDownloadUrl()}
            className="w-full rounded-full py-2 px-4 flex flex-row items-center justify-center border-0 bg-primary active:bg-btn-active hover:bg-btn-active text-font-dark"
          >
            {translate("downloadNow", l)}
          </a>
        </div>
      </div>
    </div>
  );
};

export default StoreBanner;


